import { getDataList } from './data'
import { DataListReq, DataListRes } from './data/types'
import { CreateInvoiceReq, CreateInvoiceRes, Invoice } from './invoice/types'
import { getUnitList } from './unit'
import { getWifiCardList } from './wifiCard'
import invoice from './invoice'
import { UnitGroupRes, UnitListReq } from './unit/types'
import { CheckNumberRes, GetBillRes } from './bill/types'
import { WIFICARDRes } from './wifiCard/types'
import { checkNumber, getBillInfo } from './bill'
import { CheckConsentRes, CreateConsentRes, SimRecoverRes, TanConfirmReq, TanConfirmResult, TanCreateReq, TanCreateRes } from './sim/types'
import { tanConfirm, tanCreate, get, createConsent, checkConsent } from './sim'
import { DanValidateReq, DanValidateRes } from './dan/types'
import { validate } from './dan'
import { GetEsimDevicesRes } from './info/types'
import { getEsimDevices } from './info'
import { MNP75UnitRes } from './mnp75/types'
import { getUnitList as getMnp75UnitList } from './mnp75'
import { PreorderReq, PreorderRes } from './preorder/types'
import { submitPreorder } from './preorder'
import { getNumberList, lockNumber, updateUserInfo, updateImsi, getInstance, createTan, confirmTan, saveContactInfo, createNumber, getLockedNumbers } from './number'
import { ConfirmTanReq, ConfirmTanRes, CreateTanReq, CreateTanRes, GetInstanceRes, GetLockedNumberRes, GetNumberListReq, GetNumberListRes, LockNumberReq, LockNumberRes, SaveContactInfoReq, UpdateImsiReq, UpdateImsiRes, UpdateUserInfoReq, UpdateUserInfoRes } from './number/types'
import { getCityList, getDistrictList, getQuarterList, getBuildingList } from './mobinet'
import { MobinetDistrictReq, MobinetQuarterReq, MobinetBuildingReq, MobinetCityRes, MobinetDistrictRes, MobinetQuarterRes, MobinetBuildingRes } from './mobinet/types'
import { InstanceNewNumberV2, GetNumberListReqV2, GetNumberListResV2, GetPackageInfo, SaveContactInfoReqV2, SaveNumberReqV2, SavePackageInfoReq, SetSignatureReq, TanConfirmReqV2, TanConfirmResV2, TanCreateResV2, CheckReferralRes } from './numberv2/types'
import { PackageSavePackageInfoReq, TanConfirmReqV3, InstancePackage, SaveContactInfoReqV3, CreateInstanceReq, InstancePackageShift, GetPackageListReq, PackageListRes, SelectPackageReq, SelectPackageRes, SetSignatureReqV2, TanSendReq } from './packageShift/types'
import { getInstanceV2, doSign, getAgreement, saveContactV2, saveSelfSim, saveEsim, createTanV2, confirmTanV2, getPackageInfo, savePackageInfo, getNumberListV2, saveNumberV2, checkReferral } from './numberv2'
import { createTanNumber, createTanEmail, confirmTanV3, savePackageInfoV2, saveContactV3, createInstance, getPackageList, selectPackage, getInfo, sendSign, checkReferralCode } from './packageShift'
import { sendCooperationInfo } from './cooperation'
import { getPackage, getTopupPackage, touristConfirmTanEmail, touristConfirmTanIsdn, touristCreateTanEmail, touristCreateTanIsdn, touristSaveEsim, touristSaveSelfSim } from './tourist'
import { TopupPackageRes, TouristPackage, TouristSaveSimRes, TouristTanConfirmIsdnReq, TouristTanConfirmReq, TouristTanConfirmRes, TouristTanCreateIsdnReq, TouristTanCreateReq, TouristTanCreateRes } from './tourist/types'
import { checkStatus, createTanHandset, confirmTanHandset, getHandsetDti, confirmTanHandsetV2, retryInsurance } from './handsetDti'
import { CheckStatusRequest, CheckStatusResponse, TanCreateRequest, TanCreateResponse, TanConfirmRequest, TanConfirmResponse, DanResponse, TanConfirmRequestV2, TanConfirmResponseV2 } from './handsetDti/types'

type UseMobiApi = () => {
  unit: {
    getList: (req: UnitListReq) => Promise<UnitGroupRes | undefined>
    getMnp75UnitList: (req: UnitListReq) => Promise<MNP75UnitRes | undefined>
  }
  card: {
    getList: (req: UnitListReq) => Promise<WIFICARDRes | undefined>
  }
  data: {
    getList: (req: DataListReq) => Promise<DataListRes | undefined>
  }
  bill: {
    getInfo: (isdn: string, regNo: string, type: string) => Promise<GetBillRes | undefined>
    checkNumber: (isdn: string, type: string) => Promise<CheckNumberRes | undefined>
  }
  invoice: {
    get: (_id: string) => Promise<Invoice | undefined>
    create: (req: CreateInvoiceReq) => Promise<CreateInvoiceRes | undefined>
  }
  sim: {
    tanCreate: (req: TanCreateReq) => Promise<TanCreateRes | undefined>
    tanConfirm: (req: TanConfirmReq) => Promise<TanConfirmResult | undefined>
    get: (_id: string) => Promise<SimRecoverRes | undefined>
    createConsent: (sessionId: string) => Promise<CreateConsentRes | undefined>
    checkConsent: (phoneNumber: string) => Promise<CheckConsentRes | undefined>
  }
  dan: {
    validate: (req: DanValidateReq) => Promise<DanValidateRes | undefined>
  }
  info: {
    getEsimDevices: () => Promise<GetEsimDevicesRes | undefined>
  }
  preorder: {
    submitPreorder: (req: PreorderReq) => Promise<PreorderRes | undefined>
  }
  number: {
    getNumberList: (req: GetNumberListReq) => Promise<GetNumberListRes | undefined>
    lockNumber: (req: LockNumberReq) => Promise<LockNumberRes | undefined>
    updateUserInfo: (req: UpdateUserInfoReq) => Promise<UpdateUserInfoRes | undefined>
    updateImsi: (req: UpdateImsiReq) => Promise<UpdateImsiRes | undefined>
    getInstance: (id: string) => Promise<GetInstanceRes | undefined>
    createTan: (req: CreateTanReq) => Promise<CreateTanRes | undefined>
    confirmTan: (req: ConfirmTanReq) => Promise<ConfirmTanRes | undefined>
    saveContactInfo: (req: SaveContactInfoReq) => Promise<UpdateUserInfoRes | undefined>
    createNumber: (id: string) => Promise<UpdateUserInfoRes | undefined>
    getLockedNumbers: (isdn: string) => Promise<GetLockedNumberRes | undefined>
  }
  networkCoverage: {
    getCityList: () => Promise<MobinetCityRes | undefined>
    getDistrictList: (req: MobinetDistrictReq) => Promise<MobinetDistrictRes | undefined>
    getQuarterList: (req: MobinetQuarterReq) => Promise<MobinetQuarterRes | undefined>
    getBuildingList: (req: MobinetBuildingReq) => Promise<MobinetBuildingRes | undefined>
  }
  numberv2: {
    getInstanceV2: (id: string, lang: string) => Promise<InstanceNewNumberV2 | undefined>
    createTanV2: (email: string) => Promise<TanCreateResV2 | undefined>
    confirmTanV2: (req: TanConfirmReqV2) => Promise<TanConfirmResV2 | undefined>
    getPackageInfo: (lang: string, signal: AbortSignal) => Promise<GetPackageInfo | undefined>
    savePackageInfo: (req: SavePackageInfoReq, channel: string) => Promise<InstanceNewNumberV2 | undefined>
    getNumberListV2: (req: GetNumberListReqV2) => Promise<GetNumberListResV2 | undefined>
    saveNumberV2: (req: SaveNumberReqV2) => Promise<InstanceNewNumberV2 | undefined>
    saveEsim: (instanceId: string) => Promise<InstanceNewNumberV2 | undefined>
    saveSelfSim: (instanceId: string, imsi: string) => Promise<InstanceNewNumberV2 | undefined>
    saveContactV2: (req: SaveContactInfoReqV2) => Promise<InstanceNewNumberV2 | undefined>
    getAgreement: (instanceId: string) => Promise<InstanceNewNumberV2 | undefined>
    doSign: (req: SetSignatureReq) => Promise<InstanceNewNumberV2 | undefined>
    checkReferral: (referralCode: string) => Promise<CheckReferralRes | undefined>
  }
  packageShift: {
    createTanNumber: (req: TanSendReq) => Promise<TanCreateResV2 | undefined>
    createTanEmail: (req: TanSendReq) => Promise<TanCreateResV2 | undefined>
    confirmTanV3: (req: TanConfirmReqV3) => Promise<TanConfirmResV2 | undefined>
    savePackageInfoV2: (req: PackageSavePackageInfoReq, channel: string) => Promise<InstancePackage | undefined>
    saveContactV3: (req: SaveContactInfoReqV3) => Promise<InstancePackage | undefined>
    createInstance: (req: CreateInstanceReq) => Promise<InstancePackageShift | undefined>
    getPackageList: (req: GetPackageListReq) => Promise<PackageListRes | undefined>
    selectPackage: (req: SelectPackageReq) => Promise<SelectPackageRes | undefined>
    getInfo: (instanceId: string) => Promise<InstancePackage | undefined>
    sendSign: (req: SetSignatureReqV2) => Promise<InstancePackage | undefined>
    checkReferralCode: (referralCode: string, isdn: string, instanceId: string) => Promise<CheckReferralRes | undefined>
  }
  tourist: {
    getPackage: (promoCode?: string | undefined) => Promise<TouristPackage | undefined>
    getTopupPackage: () => Promise<TopupPackageRes | undefined>
    touristCreateTanEmail: (req: TouristTanCreateReq) => Promise<TouristTanCreateRes | undefined>
    touristConfirmTanEmail: (req: TouristTanConfirmReq) => Promise<TouristTanConfirmRes | undefined>
    touristCreateTanIsdn: (req: TouristTanCreateIsdnReq) => Promise<TouristTanCreateRes | undefined>
    touristConfirmTanIsdn: (req: TouristTanConfirmIsdnReq) => Promise<TouristTanConfirmRes | undefined>
    touristSaveEsim: () => Promise<TouristSaveSimRes | undefined>
    touristSaveSelfSim: (imsi: string) => Promise<TouristSaveSimRes | undefined>
  }
  handset: {
    checkStatus: (req: CheckStatusRequest) => Promise<CheckStatusResponse | undefined>
    createTanHandset: (req: TanCreateRequest) => Promise<TanCreateResponse | undefined>
    confirmTanHandset: (req: TanConfirmRequest) => Promise<TanConfirmResponse | undefined>
    confirmTanHandsetV2: (req: TanConfirmRequestV2) => Promise<TanConfirmResponseV2 | undefined>
    getHandsetDti: (id: string) => Promise<DanResponse | undefined>
    retry: () => Promise<boolean | undefined>
  }

}
export const useMobiApi: UseMobiApi = () => {
  return {
    data: { getList: getDataList },
    unit: { getList: getUnitList, getMnp75UnitList },
    card: { getList: getWifiCardList },
    bill: { getInfo: getBillInfo, checkNumber },
    invoice: {
      get: invoice.get,
      create: invoice.create
    },
    sim: { tanCreate, tanConfirm, get, createConsent, checkConsent },
    dan: { validate },
    info: { getEsimDevices },
    preorder: { submitPreorder },
    number: { getNumberList, lockNumber, updateUserInfo, updateImsi, getInstance, createTan, confirmTan, saveContactInfo, createNumber, getLockedNumbers },
    networkCoverage: { getCityList, getDistrictList, getQuarterList, getBuildingList },
    numberv2: { getInstanceV2, createTanV2, confirmTanV2, getPackageInfo, savePackageInfo, getNumberListV2, saveNumberV2, saveEsim, saveSelfSim, saveContactV2, getAgreement, doSign, checkReferral },
    packageShift: { createTanNumber, createTanEmail, confirmTanV3, savePackageInfoV2, saveContactV3, createInstance, getPackageList, selectPackage, getInfo, sendSign, checkReferralCode },
    cooperation: { sendInfo: sendCooperationInfo },
    tourist: { getPackage, getTopupPackage, touristConfirmTanEmail, touristCreateTanEmail, touristCreateTanIsdn, touristConfirmTanIsdn, touristSaveEsim, touristSaveSelfSim },
    handset: {
      checkStatus,
      createTanHandset,
      confirmTanHandset,
      getHandsetDti,
      confirmTanHandsetV2,
      retry: retryInsurance
    }
  }
}

export interface MobiErrorRes {
  errorCode?: number
  error?: string
  cause?: {
    messageMn?: string
    messageEn?: string
  }
}
